import React, { type ReactElement } from 'react'

function Reports (): ReactElement {
  return <div>Reports</div>
}

export default Reports
